<app-navbar
  titulo="Gestão do plano"
  [backButton]="true"
  forceRota="/minhas-assinaturas"
  backgroundColor="#11235a"
  foregroundColor="#ffffff"
></app-navbar>

<app-confirmar-senha-modal
  [isOpen]="senhaCancelModalAberto"
  [isSubmitting]="isSubmittingSenhaCancel"
  tituloModal="Digite sua senha para cancelar a assinatura"
  textoBotaoConfirmar="Confirmar cancelamento"
  (closed)="fecharModalSenhaCancel()"
  (confirmed)="onSenhaCancelConfirmada($event)"
/>

<ion-content class="plano-content">
  <div class="plano-wrap">
    <div *ngIf="carregando" class="loading-wrap">
      <ion-spinner name="crescent" color="light"></ion-spinner>
    </div>

    <div *ngIf="!carregando && erro" class="error-wrap">
      <p>Não foi possível carregar os dados do plano.</p>
      <ion-button class="plano-retry" fill="outline" (click)="tentarNovamente()">Tentar novamente</ion-button>
    </div>

    <section class="plano-card" *ngIf="!carregando && !erro && possuiAssinatura">
      <p class="plano-kicker">Seu plano</p>
      <h2 class="plano-title">{{ plano.titulo || 'Plano ativo' }}</h2>

      <div class="plano-fields">
        <div class="plano-field">
          <span class="plano-field__label">Valor</span>
          <span class="plano-field__value plano-field__value--accent">{{ formatarValor(plano.valor) }} / {{ rotuloPeriodo(plano.periodicidade) }}</span>
        </div>
        <div class="plano-field">
          <span class="plano-field__label">Status</span>
          <span class="plano-field__value">{{ plano.status || '—' }}</span>
        </div>
        <div class="plano-field">
          <span class="plano-field__label">Vigência inicial</span>
          <span class="plano-field__value">{{ formatarData(plano.validadeInicio) }}</span>
        </div>
        <div class="plano-field">
          <span class="plano-field__label">Válido até</span>
          <span class="plano-field__value">{{ formatarData(plano.validadeFim) }}</span>
        </div>
        <div class="plano-field">
          <span class="plano-field__label">Método de pagamento</span>
          <span class="plano-field__value">{{ (plano.metodoPagamento || '-') | titlecase }}</span>
        </div>
        <div class="plano-field" *ngIf="plano.metodoPagamento === 'cartao' && plano.cartaoMascarado">
          <span class="plano-field__label">Cartão</span>
          <span class="plano-field__value">{{ plano.cartaoMascarado }}</span>
        </div>
        <div class="plano-field" *ngIf="plano.acessoAte">
          <span class="plano-field__label">Acesso até</span>
          <span class="plano-field__value">{{ formatarData(plano.acessoAte) }}</span>
        </div>
      </div>

      <div class="plano-actions">
        <p class="plano-actions__hint">Trocar forma de cobrança do próximo ciclo:</p>
        <ion-button
          class="plano-btn-outline"
          expand="block"
          fill="outline"
          [disabled]="alterandoMetodo || plano.metodoPagamento === 'cartao'"
          (click)="alterarMetodoPagamento('cartao')"
        >
          Usar cartão recorrente
        </ion-button>
        <ion-button
          class="plano-btn-outline"
          expand="block"
          fill="outline"
          [disabled]="alterandoMetodo || plano.metodoPagamento === 'boleto'"
          (click)="alterarMetodoPagamento('boleto')"
        >
          Usar boleto
        </ion-button>
        <ion-button
          class="plano-btn-outline"
          expand="block"
          fill="outline"
          [disabled]="alterandoMetodo || plano.metodoPagamento === 'pix'"
          (click)="alterarMetodoPagamento('pix')"
        >
          Usar Pix
        </ion-button>
      </div>

      <div class="plano-actions" *ngIf="mudancaAtiva">
        <p class="plano-actions__hint">Mudança em andamento</p>
        <div class="plano-field">
          <span class="plano-field__label">Tipo</span>
          <span class="plano-field__value">{{ mudancaAtiva.tipo_mudanca | titlecase }}</span>
        </div>
        <div class="plano-field">
          <span class="plano-field__label">Status</span>
          <span class="plano-field__value">{{ mudancaAtiva.status | titlecase }}</span>
        </div>
        <div class="plano-field" *ngIf="mudancaAtiva.valor_diferenca && mudancaAtiva.valor_diferenca !== '0.00'">
          <span class="plano-field__label">Diferença</span>
          <span class="plano-field__value">{{ formatarValor(mudancaAtiva.valor_diferenca) }}</span>
        </div>

        <ion-button
          *ngIf="permiteSimularUpgrade && mudancaAtiva.tipo_mudanca === 'upgrade' && mudancaAtiva.status === 'pendente_pagamento'"
          class="plano-btn-outline"
          expand="block"
          fill="outline"
          [disabled]="processandoTroca"
          (click)="confirmarPagamentoUpgrade()"
        >
          Simular pagamento do upgrade
        </ion-button>
        <p
          class="plano-actions__hint"
          *ngIf="!permiteSimularUpgrade && mudancaAtiva.tipo_mudanca === 'upgrade' && mudancaAtiva.status === 'pendente_pagamento'"
        >
          O upgrade será liberado depois da confirmação do pagamento da diferença no mesmo meio da assinatura.
        </p>
        <div *ngIf="pagamentoUpgrade?.pix_copia_cola || pagamentoUpgrade?.boleto_linha_digitavel">
          <p class="plano-actions__hint" *ngIf="pagamentoUpgrade?.pix_copia_cola">Pix: {{ pagamentoUpgrade?.pix_copia_cola }}</p>
          <p class="plano-actions__hint" *ngIf="pagamentoUpgrade?.boleto_linha_digitavel">
            Boleto: {{ pagamentoUpgrade?.boleto_linha_digitavel }}
          </p>
        </div>
      </div>

      <div class="plano-actions" *ngIf="!mudancaAtiva && !trocaDisponivel && mensagemTroca">
        <p class="plano-actions__hint">{{ mensagemTroca || 'Este plano não faz parte da grade atual. Cancele, use até o fim do ciclo pago e contrate um plano novo.' }}</p>
      </div>

      <div class="plano-actions" *ngIf="!mudancaAtiva && trocaDisponivel && planosDisponiveis.length > 0">
        <p class="plano-actions__hint">Trocar de plano:</p>

        <div class="plano-planos-disponiveis">
          <article class="plano-opcao" *ngFor="let item of planosDisponiveis">
            <p class="plano-opcao__titulo">{{ item.titulo }}</p>
            <p class="plano-opcao__valor">{{ formatarValor(item.valor) }} / {{ rotuloPeriodo(item.periodicidade) }}</p>
            <p class="plano-opcao__descricao" *ngIf="item.label_quando">{{ item.label_quando }}</p>
            <p class="plano-opcao__descricao" *ngIf="item.descricao">{{ item.descricao }}</p>

            <ion-button
              class="plano-btn-outline"
              expand="block"
              fill="outline"
              [disabled]="carregandoTroca || processandoTroca"
              (click)="simularTrocaPlano(item.id)"
            >
              {{ carregandoTroca ? 'Simulando...' : 'Ver condições' }}
            </ion-button>

            <div *ngIf="previewTroca?.plano_destino_id === item.id" class="plano-preview">
              <p>{{ previewTroca?.mensagem }}</p>
              <p *ngIf="previewTroca?.codigo === 'U_agora'">
                Diferença agora: {{ formatarValor(previewTroca?.valor_diferenca || '0.00') }}
                ({{ plano.metodoPagamento || 'mesmo meio da assinatura' }})
              </p>
              <p *ngIf="previewTroca?.impacto_familia?.destino_individual && (previewTroca?.impacto_familia?.membros?.length || 0) > 0">
                Perdem o acesso em {{ previewTroca?.impacto_familia?.perde_acesso_em }}:
                {{ previewNomesFamilia(previewTroca?.impacto_familia?.membros) }}
              </p>

              <ion-button
                class="plano-btn-outline"
                expand="block"
                fill="outline"
                [disabled]="processandoTroca"
                (click)="solicitarTrocaPlano(item.id)"
              >
                {{ rotuloAcaoTroca(item) }}
              </ion-button>
            </div>
          </article>
        </div>
      </div>

      <ion-button class="plano-btn-danger" expand="block" color="danger" [disabled]="cancelando" (click)="cancelarAssinatura()">
        {{ cancelando ? 'Cancelando...' : 'Cancelar assinatura' }}
      </ion-button>
    </section>

    <p class="plano-empty" *ngIf="!carregando && !erro && !possuiAssinatura">Você não possui assinatura ativa para gerenciar.</p>

    <section class="plano-card plano-card--notice" *ngIf="!carregando && !erro && !possuiAssinatura && acessoPosCancelamento.temAcesso">
      <p class="plano-kicker">Cancelamento</p>
      <h2 class="plano-title">Acesso mantido</h2>
      <p class="plano-notice-text">Seu acesso aos benefícios permanece ativo até {{ formatarData(acessoPosCancelamento.acessoAte) }}.</p>
      <ion-button class="plano-btn-outline" expand="block" fill="outline" [disabled]="processandoReativacao" (click)="reativarAssinatura()">
        {{ processandoReativacao ? 'Reativando...' : 'Reativar assinatura' }}
      </ion-button>
    </section>
  </div>
</ion-content>
